

































































import { Component, Prop } from 'vue-property-decorator';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import ProductSubType from '@/models/Products/ProductSubType';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'LendingTermSettingsEdit', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    @Prop({ required: true })
    isCreate: boolean

    @Prop({ required: false })
    productSubType: ProductSubType

    get productVM() {
        if (this.isCreate) {
            if (this.productSubType === ProductSubType.LendingFixedTerm) {
                ProductWizardModule.createProductViewModel.lendingTermSettingsAvailable = true;
            }
            return ProductWizardModule.createProductViewModel;
        }
        return ProductDetailsModule.productVM;
    }

    get periodTypeOptions() {
        return ListUtils.periodTypeOptions();
    }

    get scheduleTypeOptions() {
        return ListUtils.scheduleTypeOptions();
    }

}
